import { ApiEndpointSpecification } from './types';
import { HttpMethod } from '../http-request';
import * as Helpers from '../api-request-helpers';
import * as Types from '../types';
import { DEVICE_PDI_GRAPH } from './url-constants';

type PDIGraphEndpointSpecification = ApiEndpointSpecification;
export const PDIGraphEndpointSpecification: PDIGraphEndpointSpecification = {
    url: DEVICE_PDI_GRAPH,
    method: HttpMethod.POST,
    requestParamsSchemaName: 'PDIGraphRequestParams',
    requestBodySchemaName: 'PDIGraphRequestBody',
    okResponseSchemaName: 'PDIGraphOkResponse',
    notOkResponseSchemaName: 'GenericNotOkResponse',
    authenticated: true,
    version:2,
};

export const invokePDIGraphData = Helpers.makeApiRequestFn<
    Types.PDIGraphRequestParams,
    Types.PDIGraphRequestBody,
    Types.PDIGraphOkresponse
>(PDIGraphEndpointSpecification);
